module.exports = __webpack_public_path__ + "img/35.86b6f933.png";